import proj4 from 'proj4';

/**
 * Projects latitude and longitude coordinates into plan in french coordinates using mercator projection
 * @param latLng coordinates.
 * @returns the x and y coordinates into plan.
 */
 export const projectCoordinatesToRFG93 = (latLng: google.maps.LatLng): { x: number; y: number } => {
    proj4.defs('EPSG:2154', '+title=South france +proj=tmerc +ellps=GRS80 +datum=RGF93 +pm=paris +approx +units=m');
    const point = proj4.toPoint([latLng.lng(), latLng.lat()]);
    const projected = proj4('EPSG:4326', 'EPSG:2154', point);

    return { x: projected.x, y: projected.y };
}